<template>
  <div class="hot-topic">
    <p>
      ©1993 - {{icp_data}} 金蝶软件（中国）有限公司
      <a
        href="https://beian.miit.gov.cn"
        target="_blank"
        rel="noopener noreferrer"
        >粤ICP备05041751号</a
      >
    </p>
    <p>
      <a
        href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502002324"
        target="_blank"
        rel="noopener noreferrer"
        >粤公网安备 44030502002324号</a
      >
    </p>
    <p>
      <a
        href="https://account.kdcloud.com/privacy?id=3515729708820185088"
        target="_blank"
        rel="noopener noreferrer"
        >金蝶中国隐私政策</a
      >
    </p>

    <p>
      <a href="/api/modifyInformation" target="_blank" rel="noopener noreferrer"
        >修改个人用户信息</a
      >
    </p>
    <p>
      <a href="/api/ikdLogOff" target="_blank" rel="noopener noreferrer"
        >注销登录</a
      >
    </p>

  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ue-footer",
  components: {},
  data() {
    return {
      icp_data:new Date().getFullYear()
    };
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.hot-topic {
  height: 203px;
  background: #282828;
  padding-top: 30px;
  margin-top: 20px;
  p,
  a {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #999999;
    text-align: center;
    line-height: 14px;
    font-weight: 400;
    text-decoration: none;
  }

  a:hover {
    color: #648cf9;
  }
}
</style>